export const GET_MILEAGE_BEGIN = "GET_MILEAGE_BEGIN"
export const GET_MILEAGE_SUCCESS = "GET_MILEAGE_SUCCESS"